import React from 'react';

import { Button } from '@material-ui/core';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';

import { ButtonComponent } from '../ButtonComponent/ButtonComponent';

export function PageHeaderNav({ cancelLink, withSubmit, children }) {
  return (
    <nav>
      {children}
      {cancelLink && (
        <Button
          component={Link}
          to={cancelLink}
          style={{ minWidth: '100px', marginLeft: '10px' }}
          variant="contained"
          size="small"
        >
          Cancel
        </Button>
      )}
      {withSubmit && <ButtonComponent type="submit" color="primary" text="Save" className="ml" />}
    </nav>
  );
}

PageHeaderNav.propTypes = {
  cancelLink: PropTypes.string,
  withSubmit: PropTypes.bool,
  children: PropTypes.oneOfType([PropTypes.element, PropTypes.shape({}), PropTypes.array]),
};
PageHeaderNav.defaultProps = {
  cancelLink: '',
  withSubmit: false,
  children: null,
};
